import { styled } from '@mui/material/styles';
import { Box, Card, Button, Typography } from '@mui/material';

export const LoginContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #0d1828 0%, #162238 100%)',
  padding: '20px',
  overflow: 'auto',
  '@media (max-height: 600px)': {
    alignItems: 'flex-start',
  },
});

export const LoginCard = styled(Card)({
  maxWidth: '400px',
  width: '100%',
  padding: '40px',
  borderRadius: '12px',
  backgroundColor: '#1E2E46',
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
  margin: '20px 0',
  '@media (max-width: 480px)': {
    padding: '30px 20px',
  },
});

export const LogoContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: '36px',
});

export const Logo = styled('img')({
  width: '80px',
  height: '80px',
  marginBottom: '16px',
  objectFit: 'contain',
});

export const Title = styled(Typography)({
  color: 'white',
  fontWeight: 'bold',
  marginBottom: '8px',
  textAlign: 'center',
});

export const Subtitle = styled(Typography)({
  color: 'rgba(255, 255, 255, 0.7)',
  marginBottom: '24px',
  textAlign: 'center',
});

export const Form = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  width: '100%',
});

export const ErrorMessage = styled(Typography)({
  color: '#f44336',
  marginTop: '8px',
  fontSize: '0.875rem',
});

export const SubmitButton = styled(Button)({
  marginTop: '12px',
  padding: '12px',
  borderRadius: '8px',
  fontWeight: 'bold',
  textTransform: 'none',
  fontSize: '1rem',
  background: 'linear-gradient(90deg, #1976d2 0%, #2196f3 100%)',
  '&:hover': {
    background: 'linear-gradient(90deg, #1565c0 0%, #1976d2 100%)',
  },
});

export const ForgotPassword = styled(Typography)({
  textAlign: 'center',
  marginTop: '16px',
  color: 'rgba(255, 255, 255, 0.7)',
  cursor: 'pointer',
  '&:hover': {
    color: '#2196f3',
  },
});
